module.exports = __webpack_public_path__ + "media/images/media-elements/captions-31ef2730a22ecc4b4fecf9f90fb8d520.svg";